import { useTranslation } from 'react-i18next';
import { Modal, ModalActionType, ModalVariant } from '@/components/Modal';
import { I18nNamespace } from '@/lib/i18n-namespaces';

interface RemoveReportEventConfirmationModalProps {
    isOpen: boolean;
    count?: number;
    removeInProgress?: boolean;
    onConfirm: () => void;
    onCancel: () => void;
}

export function RemoveReportEventConfirmationModal({
    isOpen,
    count = 1,
    removeInProgress,
    onConfirm,
    onCancel,
}: RemoveReportEventConfirmationModalProps) {
    const { t } = useTranslation(I18nNamespace.REPORTS);
    const isBulk = count > 1;

    return (
        <Modal
            isOpen={isOpen}
            title={t(
                isBulk
                    ? 'detail.removeEventModal.titlePlural'
                    : 'detail.removeEventModal.title',
                { count },
            )}
            description={t(
                isBulk
                    ? 'detail.removeEventModal.bodyPlural'
                    : 'detail.removeEventModal.body',
                { count },
            )}
            onCancel={onCancel}
            onSubmit={onConfirm}
            submitInProgress={removeInProgress}
            submitText={t('detail.removeEventModal.submit')}
            size="small"
            variant={ModalVariant.PLAIN}
            actionType={ModalActionType.DANGER}
            closeOnOutsideClick
        />
    );
}
